import { API_BASE_URL } from './client';

/** .pptx / .xlsx / .zip are ZIP (PK) archives in OPC format. */
export async function diagnoseIfNotZipBlob(blob) {
  if (!(blob instanceof Blob) || blob.size === 0) {
    return 'Empty download — the server returned no bytes.';
  }

  const head = await blob.slice(0, Math.min(4, blob.size)).arrayBuffer();
  const peek = new Uint8Array(head);
  if (peek.length >= 2 && peek[0] === 0x50 && peek[1] === 0x4b) {
    return null;
  }

  const text = await blob.slice(0, 1200).text();
  const t = text.trimStart();
  const baseHint = API_BASE_URL
    ? `(API_BASE_URL="${API_BASE_URL}")`
    : `(same-origin via ${typeof window !== 'undefined' ? window.location.origin : 'browser'})`;

  if (t.startsWith('{')) {
    try {
      const j = JSON.parse(await blob.text());
      return j.error || j.message || 'JSON error payload instead of ZIP/Office file.';
    } catch (_) {
      return `Response begins with '{' but is not JSON. Preview: ${t.slice(0, 280)}`;
    }
  }

  if (t.startsWith('<!DOCTYPE') || t.startsWith('<html') || t.includes('<noscript')) {
    return (
      'Got HTML instead of an Office file. Typical causes: the browser called the wrong URL and received '
      + 'the SPA shell, or POST /api was not proxied to the API. '
      + `Check DevTools Network for POST /api/reporting/run → status and response preview. API client ${baseHint}`
    );
  }

  const hex = [...peek].map((b) => b.toString(16).padStart(2, '0')).join(' ');
  return `Not a ZIP (Office) file — first bytes: ${hex || 'none'}, length ${blob.size}. API client ${baseHint}`;
}
